import { ObjectLiteral } from "@/types/misc";
import React from "react";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { VueProxy } from "@ciao/vue-proxy";
import { ReactInVue } from "vuera";

@Component({
    name: "ReactProxy",
})
export default class ReactProxy extends Vue {
    @Prop()
    forUserId: number;

    @Prop({ required: true })
    feature: any;

    @Prop()
    featureProps?: ObjectLiteral;

    accessToken: string | null = null;

    async created() {
        console.log("Feature:", this.feature);
        this.accessToken = await this.$auth.getAccessToken();
    }

    get props() {
        return {
            apiBase: process.env.VUE_APP_API_BASE,
            forUserId: this.forUserId,
            accessToken: this.accessToken,
            clientVersion: `console v${process.env.VUE_APP_PACKAGE_VERSION}`,
            language: "en",
        };
    }

    render(h: any) {
        const XVueProxy = ReactInVue(VueProxy);

        if (!this.accessToken) return <div>Loading..</div>;

        return (
            <XVueProxy
                apiBase={process.env.VUE_APP_API_BASE}
                forUserId={this.forUserId}
                accessToken={this.accessToken}
                clientVersion={`console v${process.env.VUE_APP_PACKAGE_VERSION}`}
                language={"en"}
                feature={this.feature}
                featureProps={this.featureProps}
            />
            // featureProps={this.featureProps || {}}
        );

        // if (!this.props.accessToken) return <div>Loading...</div>;
        // return <VueProxy {...this.props}>{/*<Feature {...this.featureProps} />*/}</VueProxy>;
    }
}
